import {webviewEvents} from "@vicman-wi/webview-api/bridge";

window.webviewEvents = webviewEvents;
